import {useModelPost as useBaseModelPost} from '@/hooks/useModelPost';
import {useRouter} from '@front/hooks';

export function useModelPost(config = {}) {
  const { router, routerTo } = useRouter();

  return useBaseModelPost({ router, routerTo, ...config });
}
